import ru from "../messagesJson/ru.json";
export const PartialMessages = {
    ru,
} as const;
